import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  float: left;
  padding: 20px 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  @media (max-width: 1024px) {
  }

  main {
    float: left;
    display: flex;
    flex-direction: column;
    width: 55px;
    margin: 0 5px;
    height: 55px;
  }

  button,
  label {
    width: 55px;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0px;
    border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
    box-shadow: ${({ theme }) => `1px 5px 5px ${theme.colors.SHADOW}`};
    background-color: ${({ theme }) => theme.colors.LIGHT1};
    border-radius: 12px;
    color: ${({ theme }) => theme.colors.TEXT1};
    float: left;
    cursor: pointer;
  }

  select {
    float: left;
    margin: 0;
    width: 55px;
    margin: -55px 0 0 0;
    height: 55px;
    opacity: 0;
  }

  label {
    font-size: 18px;
    font-weight: 700;
  }

  main,
  label,
  select {
    width: 120px;
  }

  button,
  label,
  select {
    cursor: pointer;
    transition: all 0.5s ease;

    &:hover {
      background-color: ${({ theme }) => theme.colors.LIGHT2};
    }
  }

  button:disabled,
  button[disabled] {
    opacity: 0.5;
    cursor: default;
  }
`;
